export var BORDER_RADIUS_1 = '0.875rem';
export var BORDER_RADIUS_2 = '12rem';
export var BORDER_RADIUS_3 = '0.4rem';
export var BORDER_RADIUS_4 = '0.5rem';